var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hosts.length > 0)?_c('div',{staticStyle:{"padding-top":"15px"}},[_c('span',{staticStyle:{"font-size":"larger","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('network.wire.hosts') + ': '))]),_vm._l((_vm.hosts),function(item){return _c('a-tag',{key:item.id,staticClass:"mb-2"},[_vm._v(_vm._s(item.name))])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }